import { createRoute, Navigate } from '@tanstack/react-router'
import { rootRoute } from './__root'
import { useAuth, getRoleFromUser } from '../contexts/AuthContext'

function IndexPage() {
  const { user } = useAuth();

  // Redirect based on user's primary role
  const role = getRoleFromUser(user);

  if (role === 'lawyer') {
    return <Navigate to="/lawyer" replace />;
  } else if (role === 'client') {
    return <Navigate to="/client" replace />;
  } else if (role === 'enduser') {
    return <Navigate to="/tools" replace />;
  } else {
    // Default to lawyer dashboard if no specific role detected
    return <Navigate to="/lawyer" replace />;
  }
}

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: IndexPage,
})
